import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";

var _templateObject,
    _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ClassifierTree/nodes/CreateNodeContent/CreateNodeContent.styled.ts";

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
export var CreateNodeFieldLayout = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: 30px;\n  display: flex;\n  align-items: center;\n  margin: 0 3px;\n  background-color: transparent;\n  white-space: nowrap;\n  user-select: none;\n  ", ";\n"])), function (_ref) {
  var isOver = _ref.isOver;
  return isOver && 'background:rgba(92, 130, 229, 0.1); border: 2px solid rgba(76, 94, 207, 1)';
});